import { render } from "./AboutUsSection.vue?vue&type=template&id=003664a6"
const script = {}

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__